import { Route } from 'react-router-dom';

const RouteWithSubRoutes = (props) => <Route path={props.path} render={(routeProps) => <props.component {...routeProps} routes={props.routes} />} />;

export default RouteWithSubRoutes;
